import { MINUTES_PER_HOUR } from '@new/constants';

export const MINUTE_STEP = 5;
export const MINUTES_COUNT = MINUTES_PER_HOUR / MINUTE_STEP; // 60 / 5 = 12 intervals

export const DEFAULT_HOUR = '09';
export const DEFAULT_MINUTE = '00';
export const DEFAULT_TIME = '00:00';
export const DEFAULT_TIME_FORMATTED = `${DEFAULT_HOUR}:${DEFAULT_MINUTE}`;

export const PAD_LENGTH = 2;
export const PAD_CHAR = '0';
